import { textChooser } from "./textChooser"

export const genderValues = [
  { label: textChooser("txt90"), value: "M" },
  { label: textChooser("txt91"), value: "F" },
];

export const documentValues = [
  { label: "DNI", value: "1" },
  { label: textChooser("txt131"), value: "2" },
  { label: textChooser("txt132"), value: "3" },
];

export const workPlace = [
  { label: textChooser("txt147"), value: "1" },
  { label: textChooser("txt148"), value: "2" },
  { label: textChooser("txt149"), value: "3" },
]

export const workHours = [
  { label: "full-time", value: "1" },
  { label: "part-time", value: "2" },
]

export const levelExpertise = [
  { label: textChooser("txt162"), value: "1" },
  { label: textChooser("txt163"), value: "2" },
  { label: textChooser("txt164"), value: "3" },
]